





























import { Component, Vue, Watch } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import TableActions from "@/components/TableActions.vue";
import Newsletter from "@/models/newsletter";
import NewslettersAPI from "@/services/newsletters";
import { get } from "lodash";
import { Meta } from "@/models/general";

@Component({
  components: { TableActions },
})
export default class Newsletters extends Vue {
  headers = [
    {
      text: this.$t("newsletters.model.name"),
      value: "name",
    },
    {
      text: "",
      value: "actions",
    },
  ];

  records: Newsletter[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;

  created(): void {
    this.getRecords();
  }

  async getRecords(): Promise<void> {
    this.loading = true;
    try {
      const r = await NewslettersAPI.list(
        this.meta.pagination.current,
        // this.meta.pagination.size
        30
      );
      this.records = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  editRecord(id: string): void {
    console.log(id);
    this.$router.push({ name: "editNewsletter", params: { id } });
  }

  deleteRecord(id: string): void {
    LayoutModule.setDialogTitle("definitions.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await NewslettersAPI.delete(id);
        await this.getRecords();
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getRecords();
  }
}
